export type FeatureFlags = "useMocks" | "newProductDetails" | "newPaymentDetails" | "previewAnnouncements";
function getFeatureFlag(flag: FeatureFlags) {
  // Window doesn't exist when this gets imported for the e2e test runner (Node runtime)
  if (typeof window === "undefined") {
    return false;
  }
  // Set Feature Flag if this is a Vercel preview and it hasn't been set
  if (window.location.hostname.includes("vercel.app") && localStorage.getItem(flag) === null) {
    localStorage.setItem(flag, "true");
  }
  return localStorage.getItem(flag) === "true";
}

// !!If you are adding a new feature flag, you need to also update the roadmap below
// https://blurb-books.atlassian.net/wiki/spaces/ingcon/pages/4198072322/Roadmap
export const featureFlags: Record<FeatureFlags, boolean> = {
  useMocks: getFeatureFlag("useMocks"),
  previewAnnouncements: getFeatureFlag("previewAnnouncements"),
  newProductDetails: getFeatureFlag("newProductDetails"),
  newPaymentDetails: true,
};
